module.exports = __webpack_public_path__ + "static/media/facebook.178a0a56.svg";